<div class="enrichment-theme-dialog-container" [style.background-image]="'url(' + themeUrl + ')'">
  <div class="enrichment-theme-dialog-overlay-content">
    <h3>{{ data.dogNames }} {{ data.subHeader }}</h3>
    <p>{{ data.themeName }} </p>
  </div>
  <div class="enrichment-theme-dialog-footer">
    <div class="footer-image" [style.background-image]="'url(' + logoImage + ')'"></div>
  </div>
</div>